export const EVENTO_LOCALIZACAO_ATUALIZADA = "localizacao-atualizada";

export const paraPosicao = (latitude, longitude) => {
	const lat = parseFloat(latitude);
	const lng = parseFloat(longitude);

	return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

export const temLocalizacaoExata = (latitude, longitude) => paraPosicao(latitude, longitude) !== null;

export const urlDoLocalNoGoogleMaps = (posicao) => `https://www.google.com/maps?q=${posicao.lat},${posicao.lng}`;
